// Fired when the API hands out a renewed token (see clients/axios.js)
export const TOKEN_REFRESHED_EVENT = "auth-token-refreshed";

// Returns the token's expiry time in ms, or null if the token can't be decoded.
export const getTokenExpiry = (token) => {
  try {
    const base64 = token.split(".")[1].replace(/-/g, "+").replace(/_/g, "/");
    const payload = JSON.parse(atob(base64));
    return payload.exp ? payload.exp * 1000 : null;
  } catch (e) {
    return null;
  }
};

export const IsUserLoggedIn = () => {
  const apiToken = localStorage.getItem("authorization");
  if (typeof apiToken !== "string" || apiToken.trim().length === 0) {
    return false;
  }
  const expiry = getTokenExpiry(apiToken);
  return expiry !== null && expiry > Date.now();
};

export const redirectToLogin = () => {
  localStorage.clear();
  if (window.location.pathname !== "/login") {
    window.location.replace("/login");
  }
};
